import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import caltexLineProfile from '../../../assets/images/pages/member/caltex-lineprofile.png';
import caltexPointImg from '../../../assets/images/pages/member/caltex-point.png';
import { UserRole } from '../../../constants/role';
import { useUserStore } from '../../../stores/userStore';

const MemberCard = () => {
  const userInfo = useUserStore((state) => state.userInfo);
  const companyInfo = useUserStore((state) => state.companyInfo);

  const userData = [
    {
      label: 'รหัสบริษัท',
      value: companyInfo?.code || 'XXXX',
    },
    {
      label: 'ชื่อบริษัท',
      value: companyInfo?.company_name || 'XXXX',
    },
    {
      label: 'ชื่อผู้มีสิทธิ์แลกรางวัล',
      value: companyInfo?.people_name || 'XXXX',
    },
    {
      label: 'เกณฑ์ขั้นต่ำต่อเดือน\nของบริษัทท่าน',
      value: companyInfo?.state === 'ACCOUNT READY' ? companyInfo?.spending_criteria : 'XXXX',
    },
  ];

  return (
    <Box sx={{ padding: '16px' }}>
      {/* Card */}
      <Box
        display="flex"
        gap={2}
        alignItems="center"
        sx={{
          width: '100%',
          height: '150px',
          margin: '0 auto',
          padding: '10px',
          backgroundColor: '#005972',
          borderRadius: '15px',
          marginBottom: '15px',
          position: 'relative',
        }}
      >
        <Box>
          {userInfo?.role_id.name === UserRole.ADMIN && (
            <Link to="/admin">
              <Box
                sx={{
                  width: '90px',
                  height: '90px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  backgroundColor: `${companyInfo?.user_id._id === userInfo?._id ? '#000' : 'white'} `,
                }}
              >
                <img
                  src={userInfo?.pictureUrl || caltexLineProfile}
                  alt="Line Profile"
                  style={{ width: '80px', height: '80px', borderRadius: '50%' }}
                />
              </Box>
            </Link>
          )}

          {userInfo?.role_id.name !== UserRole.ADMIN && (
            <Box
              sx={{
                width: '90px',
                height: '90px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: `${companyInfo?.user_id._id === userInfo?._id ? '#000' : 'white'} `,
              }}
            >
              <img
                src={userInfo?.pictureUrl || caltexLineProfile}
                alt="Line Profile"
                style={{ width: '80px', height: '80px', borderRadius: '50%' }}
              />
            </Box>
          )}
        </Box>
        <Box>
          <Typography
            component="h1"
            sx={{ fontSize: '2.25rem', color: 'white', lineHeight: '1.85rem' }}
          >
            {userInfo?.displayName || '-'}
          </Typography>
          <Typography
            component="h2"
            sx={{ fontSize: '1.5rem', lineHeight: '1.5rem', color: 'white', marginBottom: '.5rem' }}
          >
            คะแนนสะสม
          </Typography>
          <Box display="flex" alignItems="flex-start" gap={1.25}>
            <img src={caltexPointImg} alt="Caltex Point" style={{ width: '25px' }} />
            <Typography
              component="p"
              sx={{ fontSize: '2.25rem', lineHeight: '1.75rem', color: 'white' }}
            >
              {companyInfo?.accumulated_points.toFixed(2) || '0'}{' '}
              <span style={{ fontSize: '1.5rem' }}>คะแนน</span>
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            width: '0',
            height: '0',
            borderStyle: 'solid',
            borderWidth: '0 0px 60px 60px',
            borderColor: 'transparent transparent #E1000C transparent',
            transform: 'rotate(0deg)',
            position: 'absolute',
            bottom: '0',
            right: '0',
            zIndex: '10',
            borderBottomRightRadius: '10px',
          }}
        />
      </Box>

      {/* Information */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        {userData.map((data, index) => {
          return (
            <Box
              key={Math.random() + index}
              sx={{
                width: '100%',
                minHeight: '50px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px',
                backgroundColor: 'white',
                padding: '10px 16px',
                borderRadius: '10px',
              }}
            >
              <Box width="54%">
                <Typography
                  sx={{
                    fontSize: '1.5rem',
                    fontWeight: '500',
                    lineHeight: '1.5rem',
                    color: '#004B61',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {data.label}
                </Typography>
              </Box>
              <Box width="44%">
                <Typography
                  sx={{
                    fontSize: '1.5rem',
                    lineHeight: '1.5rem',
                    color: '#004B61',
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  {data.value}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default MemberCard;
